<template>
    <div class="card--import-contacts__option background--white">
        <div
            :class="[ 'card--import-contacts__option__icon background--default display--flex' ]"
        >
            <slot name="card__icon" />
        </div>
        <div
            :class="[ 'card--import-contacts__option__title color--dark capitalize' ]"
        >
            <slot name="card__title" />
        </div>
        <div
            :class="[ 'card--import-contacts__option__templates' ]"
        >
            <base-templates :templates="templates"/>
        </div>
    </div>
</template>

<script>

export default {
    components: {
        BaseTemplates: () => import( /* webpackChunkName: 'BaseTemplates' */ '@/components/bundles/templates/BaseTemplates' )
    },
    props: {
        templates: {
            type: Object,
            default: () => ({ have: false })
        }
    }
};
</script>

<style lang="scss">
    .card {
        &--import-contacts {
            &__option {
                width: auto;
                max-width: 221px;
                padding: 30px;
                @include rounded-corner( 22px );
                @include element-border( $color-white );
                @include box-shadow( 0 3px 30px #70707033 );
                @include transition( all .2s ease-in-out );
                &:hover {
                    @include element-border( $color-green );
                    &__title {
                        color: $color-green;
                    }
                }
                &--selected {
                    @include element-border( $color-green );
                }
                &__icon {
                    @include dimensions( 100%, 132px );
                    max-width: 165px;
                    align-items: center;
                    justify-content: center;
                    @include rounded-corner( 22px );
                    margin: 0 auto;
                }
                &__title {
                    margin-top: 30px;
                    @include typography-specs( 20px, 24px, 700 );
                    text-align: center;
                    padding: 0 25px;
                }
            }
        }
    }
</style>